export default __webpack_public_path__ + "static/media/apptractive-logo-full.b4ac36bd.png";